<template>
  <BaseSection v-if="getCurrentStep>=step">
    <template #title>{{step}}. Update Tariff</template>

    <template #content>
      <template v-if="getIsAnyTariffChanged">
        <div class="font-weight-bold error--text">Current</div>
      </template>
      
      <div :class="`d-flex justify-space-between ${getIsTariffChanged?'error--text':''}`">
        <div>Tariff</div><div>{{getSection('tariff').previous.tariff ? getSection('tariff').previous.tariff.text : '-'}}</div>
      </div>

      <div :class="`d-flex justify-space-between ${getIsLengthChanged?'error--text':''}`">
        <div>Contract length</div><div>{{getSection('tariff').previous.length ? getSection('tariff').previous.length.text : '-'}}</div>
      </div>

      <div :class="`d-flex justify-space-between ${getIsPromoChanged?'error--text':''}`">
        <div>Promo</div><div>{{getSection('tariff').previous.promo ? getSection('tariff').previous.promo.text : '-'}}</div>
      </div>

      <template v-if="getIsAnyTariffChanged">
        <v-divider class="my-2" />
        <div class="font-weight-bold secondary--text">Updated</div>
      </template>

      <template v-if="getIsTariffChanged">
        <div class="d-flex justify-space-between secondary--text">
          <div>Tariff</div><div>{{getSection('tariff').tariff.text}}</div>
        </div>
      </template>

      <template v-if="getIsLengthChanged">
        <div class="d-flex justify-space-between secondary--text">
          <div>Contract length</div><div>{{getSection('tariff').length.text | customPlaceholder}}</div>
        </div>
      </template>

      <template v-if="getIsPromoChanged">
        <div class="d-flex justify-space-between secondary--text">
          <div>Promo</div><div>{{getSection('tariff').promo.text | customPlaceholder}}</div>
        </div>
      </template>

    </template>
  </BaseSection>
</template>

<script>
  import { mapGetters } from 'vuex';
  import BaseSection from '@/components/Products/ProductTypes/AllProducts/ChangeTariff/ChangedSections/BaseSection';

  export default {

    props: {
      step: {
        type: Number,
        default: 0
      },
    },

    components: {BaseSection},

    computed: {
      ...mapGetters('changeTariff',['getCurrentStep','getSection','getIsAnyTariffChanged','getIsTariffChanged','getIsLengthChanged','getIsPromoChanged']),
    },

  }
</script>

<style lang="scss" scoped></style>
